<template lang="pug">
div
  announcement
  .container
    .member-wrapper
      .member-content
        .member-title {{ $t("ui.registration") }}
        .member-form
          form
            .form-field
              .form-label {{ $t("ui.account_id") }}
              .input-group
                input.form-control(
                  type='text'
                  v-model.trim.lazy="$v.accountID.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.accountID" :name="$t('ui.account_id')")  
            .form-field
              .form-label {{ $t("ui.password_new") }}
              .input-group
                input.form-control(
                  type='password'
                  v-model.trim.lazy="$v.newPassword.$model"
                  :disabled="loading"
                  :maxLength="$v.newPassword.$params.maxLength.max"
                )
              ValidateResult(:value="$v.newPassword" :name="$t('ui.password_new')" :name2="$t('ui.password_current')")  
            .form-field
              .form-label {{ $t("ui.password_confirm") }}
              .input-group
                input.form-control(
                  type='password'
                  v-model.trim.lazy="$v.confirmPassword.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.confirmPassword" :name="$t('ui.password_confirm')" :name2="$t('ui.password_new')")  
            .form-field
              .form-label {{ $t("ui.full_name") }}
              .input-group
                input.form-control(
                  type='text'
                  v-model.trim.lazy="$v.fullName.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.fullName" :name="$t('ui.full_name')")
            .form-field
              .form-label {{ $t("ui.contact_phone") }}
              .input-group
                input.form-control(
                  type='text'
                  v-model.trim.lazy="$v.contactPhone.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.contactPhone" :name="$t('ui.contact_phone')")
            .form-field
              .form-label {{ $t("ui.contact_email") }}
              .input-group
                input.form-control(
                  type='text'
                  v-model.trim.lazy="$v.contactEmail.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.contactEmail" :name="$t('ui.contact_email')")
            .form-field
              .form-label {{ $t("ui.tac_code") }}
              .tac-group
                .input-group.flex-grow-1
                  input.form-control(
                    type='text'
                    v-model.trim.lazy="$v.tacCode.$model"
                    :disabled="loading"
                  )
                .btn-form.align-self-stretch
                  a.d-flex(href='javascript:void(0);' @click="getTAC()")
                    .btn-tac#countdown {{ $t("ui.request_tac") }}
                    //- template(v-if="tacCountdown <= 0")
                    //-   .btn-tac {{ $t("ui.request_tac") }} 
                    //- template(v-else)
                    //-   .btn-tac {{ tacCountdown }} (s)
              ValidateResult(:value="$v.tacCode" :name="$t('ui.tac_code')")
            .btn-form.py-2.py-xl-3
              a(href='javascript:void(0);' @click="register")
                .btn-submit {{ $t("ui.register") }}
  //- seo
</template>

<script>
import { required, minLength, maxLength, email, not, sameAs } from 'vuelidate/lib/validators'

export default {
  components: {
    announcement: () => import("@/components/_announcement"),
    seo: () => import("@/components/_seo"),
    ValidateResult: () => import("@/library/ValidateResult")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      loginID: "",
      accountID: "",
      newPassword: "",
      confirmPassword: "",
      fullName: "",
      contactPhone: "",
      contactEmail: "",
      tacCode: "",
      tacCountdown: 0
    }
  },
  validations: {
    accountID: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      notSameAs: not(sameAs('oldPassword')),
      passwordFormat: function(value){
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        //const containsSpecial = /[#?!@$%^&*-]/.test(value)
        return containsUppercase && containsLowercase && containsNumber;
      }
    },
    confirmPassword: {
      required,
      sameAs: sameAs("newPassword")
    },
    fullName: {
      maxLength: 50
    },
    contactPhone: {
      maxLength: 11,
      phoneFormat: function(value) {
        var regex = /^976(70|75|76|77|78|86|88|89|90|91|93|94|95|96|97|98|99)\d{6}$/
        return regex.test(value)
      }
    },
    contactEmail: {
      email
    },
    tacCode: {
      required
    }
  },
  computed: { 
    tacExpiry() {
      return this.$store.getters.tacExpiry
    }
   },
  mounted() {
    // Check if the page's URL has query parameters
    const queryParameters = window.location.search;
    
    if (queryParameters) {
      // The URL has query parameters
      const params = new URLSearchParams(queryParameters);

      // Access and use query parameters as needed
      const someParam = params.get('login_id'); // Replace with the name of your query parameter
      this.loginID = someParam;
      // console.log('Query parameters found:', someParam);
    } else {
      // The URL does not have query parameters
      // console.log('No query parameters found.');
    }
  },
  methods:{
    setCountdown() {
      let vm = this
      if(vm.tacExpiry) {
        var countdownInterval = setInterval(function() {
          // Calculate remaining time in seconds
          var expired = vm.$moment(vm.tacExpiry)
          var now = vm.$moment()
          var remainingTime = vm.$moment.duration(expired - now)

          // Display the countdown in seconds
          var formattedTime = Math.floor(remainingTime.asSeconds())

          // Update the countdown element
          document.getElementById("countdown").textContent = formattedTime + " (s)";
          // vm.tacCountdown = formattedTime

          // Check if the countdown has reached zero
          if (remainingTime.asMilliseconds() <= 0) {
            clearInterval(countdownInterval)
            document.getElementById("countdown").textContent = vm.$t("ui.request_tac");
            // console.log("Countdown expired!")
          }
        }, 1000);
      }      
    },
    getTAC() {
      let login_id = this.accountID
      let contact_phone = this.contactPhone
      this.$store
        .dispatch("user/getTAC", { login_id, contact_phone })
        .then(response => {
          if (response.success == true) {
            this.$store.dispatch("user/setTACExpiry", response.data[0].tac_expiry)
            this.setCountdown()
          } else {
            this.setCountdown()
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
          }
        })
        .catch(response => {
          this.setCountdown()
          this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
        });
    },
    register(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let login_id = this.loginID
        let account_id = this.accountID
        let password = this.newPassword
        let full_name = this.fullName
        let contact_phone = this.contactPhone
        let contact_email = this.contactEmail
        let tac_code = this.tacCode
        this.loading = true
        this.$store
          .dispatch("user/addMember", { login_id, account_id, password, full_name, contact_phone, contact_email, tac_code })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.reset()
              this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.addmember_success"), "success");
              this.$router.push("/").catch(error =>{})
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error");
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error");
          });
      }
    },
    reset() {
      this.accountID = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.fullName = ""
      this.contactPhone = ""
      this.contactEmail = ""
      this.tacCode = ""
      this.tacCountdown = 0
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    }
  }
}
</script>